<template>
  <div>
    <!-- List -->
    <div>
      <vs-table id="product_list" class="vs-con-loading__container" stripe :sst="true" maxHeight="800px"
        @search="updateSearchQuery" @change-page="handleChangePage" @sort="handleSort" :total="FilteredCount"
        :max-items="length" search :data="records">
        <template slot="header">
          <div class="mb-2 flex items-center">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div
                    class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (FilteredCount && 1)) || 0 }}
                      -
                      {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                      of {{ total || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
            <div v-if="checkPermissionSlug(['audio_create'])" @click="toggleAddModal"
              class="btn-add-new p-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add {{ module_name }}</span>
            </div>

            <div class="flex flex-wrap items-center">
              <!-- Custom Pagination -->
              <vs-pagination v-if="FilteredCount" v-model="page" :total="totalPages"
                :max="totalPages / length > 7 ? 7 : 5" class="mt-1" @onchange="handleChangePage"></vs-pagination>
            </div>
            <div class="flex items-center mb-3 mx-2 input-group">
              <label>&nbsp;</label>
              <select-2 class="w-full" name="Creator" placeholder="Select Creator" :value="creatorVal"
                @input="(item) => (creatorVal = item && item.value)" autocomplete :ssr="true" :multiple="false"
                action="creator/get" />
            </div>
            <div class="vx-row mb-3 mx-2 input-group">
              <label>&nbsp;</label>
              <flat-pickr v-model="dateRange" :config="datePickerConfig" placeholder="Select Date" class="w-full"
                id="dateRange" name="dateRange" />
              <feather-icon v-if="dateRange" icon="XIcon" svgClasses="h-6 w-6 text-danger" data-clear
                v-tooltip="'Clear'" @click="clearDateRange" />
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th>Reorder</vs-th>
          <vs-th>Sr#</vs-th>
          <vs-th>Thumbnail</vs-th>
          <!-- <vs-th>Image</vs-th> -->
          <vs-th sort-key="title">Title</vs-th>
          <vs-th sort-key="category">Category</vs-th>
          <vs-th sort-key="audio">Audio</vs-th>
          <vs-th sort-key="total_impressions">Impressions</vs-th>
          <vs-th sort-key="total_streams">Streams</vs-th>
          <vs-th sort-key="creator">Creator</vs-th>
          <vs-th v-if="checkPermissionSlug(['audio_edit'])" sort-key="status">Visible</vs-th>
          <vs-th v-if="checkPermissionSlug(['audio_edit']) || checkPermissionSlug(['audio_delete'])">Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <draggable :list="localRecords" tag="tbody" handle=".drag-handle" @end="onDragEnd">
            <vs-tr :data="tr" :key="tr._id" v-for="(tr, i) in localRecords">
              <vs-td class="drag-handle" title="Reorder">
                ::
              </vs-td>
              <vs-td>
                {{ page * length - (length - i - 1) }}
              </vs-td>
              <vs-td>
                <img :src="tr.thumbnail" class="object-cover" height="85px" width="85px" :alt="tr.title" />
              </vs-td>
              <vs-td class="text-left">
                <span class="cursor-pointer" v-if="checkPermissionSlug(['audio_edit'])"
                  @click.stop="toggleEditModal(tr)" v-tooltip="{ content: `Edit ${tr.title}` }">{{ tr.title || '-' }}
                </span>
                <span v-else>{{ tr.title || '-' }} </span>
              </vs-td>
              <vs-td class="text-left">{{ tr.category || '-' }} </vs-td>
              <vs-td class="text-left">
                <audio ref="audios" :src="tr.audio" controls @play="handlePlay(i)"></audio>
              </vs-td>
              <vs-td class="text-left">
                <span class="cursor-pointer">{{ tr.total_impressions }} </span>
              </vs-td>
              <vs-td class="text-left">
                <span class="cursor-pointer">{{ tr.total_streams }} </span>
              </vs-td>
              <vs-td class="text-left cursor-pointer">
                <span @click="redirectToAudioWithCreator(tr.creators && tr.creators[0] ? tr.creators[0].name : '-')"
                  v-tooltip="{ content: `View ${tr.creators && tr.creators[0] ? tr.creators[0].name : '-'}` }">
                  {{ tr.creators && tr.creators[0] ? tr.creators[0].name : '-' }}
                </span>
              </vs-td>

              <vs-td class="text-left" v-if="checkPermissionSlug(['audio_edit'])">
                <vs-switch icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" color="primary"
                  :value="tr.is_active" @click.stop="updateStatus(tr._id, !tr.is_active)">
                  <span slot="on"></span>
                  <span slot="off"></span>
                </vs-switch>
              </vs-td>
              <vs-td v-if="checkPermissionSlug(['audio_edit']) || checkPermissionSlug(['audio_delete'])">
                <div class="inline-flex">
                  <vx-tooltip :text="`Edit ${module_name}`" v-if="checkPermissionSlug(['audio_edit'])">
                    <feather-icon @click.stop="toggleEditModal(tr)" icon="EditIcon"
                      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                  </vx-tooltip>
                  <vx-tooltip :text="`Delete ${module_name}`" v-if="checkPermissionSlug(['audio_delete'])">
                    <feather-icon @click.stop="deleteRecord(tr._id)" icon="Trash2Icon"
                      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </draggable>
        </template>
      </vs-table>
    </div>

    <!-- Add modal -->
    <action-modal :module_name="module_name" @update-data="getData" v-if="isAddModalMounted"
      :showModal.sync="isAddModalShow" :action_name="'Add'" />

    <!-- Edit modal -->
    <action-modal :module_name="module_name" @update-data="getData" v-if="isEditModalMounted"
      :showModal.sync="isEditModalShow" :data="selectedRecord" :action_name="'Update'" />

    <!-- Analytics modal -->
    <!-- <analytics-modal :module_name="module_name" v-if="isAnalyticsModalMounted" :showModal.sync="isAnalyticsModalShow" :data="selectedRecord" :action_name="'Analytics'" /> -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import actionModal from '@/views/audio/action'
// import analyticsModal from '@/views/audio/analytics'
import 'flatpickr/dist/flatpickr.css'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'
import draggable from 'vuedraggable'

export default {
  name: 'AudioList',

  /** Components */
  components: {
    actionModal,
    flatPickr,
    Select2,
    draggable
    // analyticsModal
  },

  /** Data */
  data() {
    const startOfMonth = moment().startOf('month').format('DD-MM-YYYY') // First day of the month
    const today = moment().format('DD-MM-YYYY') // Today's date
    return {
      order: [],
      length: 100,
      page: 1,
      search: '',
      creatorVal: null,
      module_name: 'Audio',

      // Add modal
      isAddModalMounted: false,
      isAddModalShow: false,

      // Edit modal
      isEditModalMounted: false,
      isEditModalShow: false,

      // Analytics modal
      // isAnalyticsModalMounted: false,
      // isAnalyticsModalShow: false,

      selectedRecord: null,

      dateRange: `${startOfMonth} to ${today}`, // Automatically set to current month
      datePickerConfig: {
        wrap: true,
        mode: 'range', // Enables date range selection
        dateFormat: 'd-m-Y',
        maxDate: today, // Disable future dates
        defaultDate: [startOfMonth, today] // Pre-select this month's start date to today
      },
      sortableInstalled: false
    }
  },

  /** computed */
  computed: {
    ...mapState('audio', ['records', 'total', 'FilteredCount', 'listLoading']),
    ...mapGetters('auth', ['checkPermissionSlug']),
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    },
    localRecords: {
      get() {
        return this.records
      },
      set(val) {
        this.$store.commit('audio/SET_STATE', { action: 'records', data: val })
      }
    }
  },

  /** Functions */
  methods: {
    ...mapActions('audio', {
      analyticWiseList: 'analyticWiseList',
      delete: 'delete',
      updateSequence: 'updateSequence'
    }),

    /**
     * Handle the play event for an audio element.
     * Pauses all other audios except the one being played.
     * @param {Number} currentIndex - The index of the audio being played.
     */

    handlePlay(currentIndex) {
      if (this.$refs.audios) {
        // Convert $refs.audios to an array if it's not already
        const audios = Array.isArray(this.$refs.audios) ? this.$refs.audios : [this.$refs.audios]

        audios.forEach((audio, index) => {
          if (index !== currentIndex) {
            audio.pause()
          }
        })
      }
    },
    /**
     * Pause all audio elements and reset their playback.
     */

    pauseAllAudios() {
      if (this.$refs.audios) {
        const audios = Array.isArray(this.$refs.audios) ? this.$refs.audios : [this.$refs.audios]

        audios.forEach((audio) => {
          audio.pause()
          audio.currentTime = 0
        })
      }
    },

    clearDateRange() {
      this.dateRange = null // Clear the dateRange value
    },

    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    /** Sorting Table Data */
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    /** Search Query */
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    /** List API */
    getData() {
      let start_date = null
      let end_date = null
      if (this.dateRange) {
        const dateRangeArray = this.dateRange.split(' to ')
        // Adjust parsing to match the new format 'DD-MM-YYYY'
        start_date = moment(dateRangeArray[0], 'DD-MM-YYYY').startOf('day').utc().format() // Set to start of day in UTC
        end_date = dateRangeArray[1]
          ? moment(dateRangeArray[1], 'DD-MM-YYYY').endOf('day').utc().format() // Set to end of day in UTC
          : moment(dateRangeArray[0], 'DD-MM-YYYY').endOf('day').utc().format()
      }
      this.analyticWiseList({
        // order: this.order,
        limit: this.length,
        page: this.page,
        search: this.search,
        start_date,
        end_date,
        creator: this.creatorVal
      })
    },

    // Add modal
    toggleAddModal() {
      this.pauseAllAudios() // Pause all audios when adding
      this.isAddModalMounted = true
      this.isAddModalShow = true
    },

    // Edit modal
    toggleEditModal(data) {
      this.pauseAllAudios() // Pause all audios when editing
      this.isEditModalMounted = true
      this.isEditModalShow = true
      this.selectedRecord = data
    },

    // toggleAnalyticsModal(data) {
    //   this.pauseAllAudios() // Pause all audios when editing
    //   this.isAnalyticsModalMounted = true
    //   this.isAnalyticsModalShow = true
    //   this.selectedRecord = data
    // },

    // Redirect to Audio module and search by creator
    redirectToAudioWithCreator(creator) {
      this.$router.push({
        path: '/creator/list',
        query: { creator } // Pass the creator ID as query param
      })
    },

    /** Delete Confirmation */
    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete this record?`,
        accept: () => this.deleteSingleRecord(id),
        acceptText: 'Delete'
      })
    },

    /** Delete API */
    async deleteSingleRecord(id) {
      try {
        const { message } = await this.delete(id)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          position: 'top-center',
          time: 5000,
          icon: 'icon-alert-circle',
          color: 'primary'
        })
      }
    },
    /** updateStatus API */
    updateStatus(id, status) {
      this.$store
        .dispatch('audio/updateStatus', {
          id,
          status
        })
        .then((Success) => {
          const { message } = Success
          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'success'
          })
        })
        .catch((err) => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
        })
    },
    onDragEnd() {
      // Compute per-creator sequence: each creator's audios get 0, 1, 2...
      // based on their relative order in the current full (possibly unfiltered) list.
      const creatorSequenceCounter = {}
      const sequences = this.localRecords.map((item) => {
        // Use first creator's _id as the grouping key, fallback to 'none'
        const creatorKey =
          item.creators && item.creators[0]
            ? item.creators[0]._id || item.creators[0]
            : 'none'

        if (creatorSequenceCounter[creatorKey] === undefined) {
          creatorSequenceCounter[creatorKey] = 0
        } else {
          creatorSequenceCounter[creatorKey]++
        }

        return {
          id: item._id,
          sequence: creatorSequenceCounter[creatorKey]
        }
      })

      this.updateSequence({ data: sequences }).then(() => {
        this.$vs.notify({
          title: 'Success',
          text: 'Order updated successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 3000,
          color: 'success'
        })
      }).catch(err => {
        this.$vs.notify({
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'danger'
        })
        this.getData()
      })
    }
  },

  /** Watchers */
  watch: {
    creatorVal() {
      this.page = 1 // Reset to the first page when creator changes
      this.getData()
    },
    dateRange() {
      this.page = 1 // Reset to the first page when date range changes
      this.getData()
    },
    listLoading() {
      if (this.listLoading) {
        this.$vs.loading({
          container: '#product_list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#product_list > .con-vs-loading')
      }
    },

    // Add modal
    isAddModalShow: {
      immediate: true,
      handler(newVal) {
        this.toggleBodyScroll()
        if (!newVal) {
          setTimeout(() => {
            this.isAddModalMounted = false
          }, 0)
        }
      }
    },

    // Edit modal
    isEditModalShow: {
      immediate: true,
      handler(newVal) {
        this.toggleBodyScroll()
        if (!newVal) {
          setTimeout(() => {
            this.isEditModalMounted = false
          }, 0)
        }
      }
    },
    // isAnalyticsModalShow: {
    //   immediate: true,
    //   handler(newVal) {
    //     if (!newVal) {
    //       setTimeout(() => {
    //         this.isAnalyticsModalMounted = false
    //       }, 0)
    //     }
    //   }
    // },

    page() {
      this.getData()
    }
  },

  /** On Rendering */
  mounted() {
    this.getData()
  },

  beforeDestroy() {
    this.pauseAllAudios()
    document.body.style.overflow = 'auto'
  }
}
</script>
<style>
.input-group .feather-icon {
  position: absolute;
  top: 30px;
  right: 10%;
  transform: translateY(-50%);
  cursor: pointer;
}

#dateRange {
  width: 350px !important;
}

.drag-handle {
  cursor: grab !important;
  user-select: none;
  touch-action: none;
  font-size: 1.25rem;
  line-height: 1.75rem;
  text-align: center;
}

.drag-handle:active {
  cursor: grabbing !important;
}

.sortable-ghost {
  opacity: 0.3;
  background-color: #f1f1f1 !important;
}

.sortable-chosen {
  background-color: #fafafa !important;
}

.sortable-fallback {
  opacity: 1 !important;
  background-color: #fff !important;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  display: table !important;
  width: auto !important;
}

.sortable-fallback td {
  background-color: #fff !important;
}
</style>
